import { TransitionKind } from "@repo/api/transition";
import { ImageTransitionBuilder } from "./ImageTransitionBuilder.ts";
import { msToFrames } from "../../utils/timing.ts";

const transitionKind = TransitionKind.enum.NONE;

export const ImageNoneTransitionBuilder: ImageTransitionBuilder<
  Record<string, unknown>
> = {
  formConfig: {
    kind: transitionKind,
    buildDefaultValue: () => ({ kind: transitionKind }),
  },

  getPreviewClipDurationsInFrames: (props) => ({
    previewClip1DurationInFrames: msToFrames(1400, props.fps),
    previewClip2DurationInFrames: msToFrames(1800, props.fps),
  }),
};
